import { Horizontal } from "Components/Horizontal";
import { HorizontalError } from "Components/HorizontalError";
import { WhatIsThisModal } from "Components/WhatIsThisModal";
import * as DateFns from "date-fns";
import { Checkbox } from "Inputs/Checkbox";
import { dateFormat } from "Inputs/DateInput";
import { VerticalRadio } from "Inputs/Radio";
import { Textbox } from "Inputs/Textbox";
import React from "react";
import { useFormikContext } from "formik";
import { formatDollarsAndCents } from "Tools";
import { BankAccountOptions } from "SharedConstants";
import { BankAccountInputProps } from "SharedConstants/Schema";

export function BankAccountInput(
  props: BankAccountInputProps & {
    TotalCost: number;
    merchantName: string;
  },
) {
  const { errors } = useFormikContext<any>();
  return (
    <>
      <HorizontalError>{errors["BANK_ACCOUNT_NUMBER"]}</HorizontalError>
      <Horizontal isRequired label="Account Type" shouldNotPadLabel>
        <VerticalRadio
          fieldName="AccountType"
          options={[
            [BankAccountOptions.Checking, "Checking"],
            [BankAccountOptions.Savings, "Savings"],
          ]}
        />
      </Horizontal>
      <Horizontal isRequired label="Name">
        <Textbox
          fieldName="AccountName"
          placeholder="Name on Account"
          inputProps={{ autoComplete: "off" }}
        />
      </Horizontal>
      <Horizontal
        isRequired
        label={
          <>
            Routing Number <RoutingAndAccountWhatIsThis />
          </>
        }
      >
        <Textbox
          type="tel"
          fieldName="RoutingNumber"
          placeholder="Routing Number"
          inputProps={{ autoComplete: "off" }}
        />
      </Horizontal>
      <AccountNumberInput />
      <Horizontal>
        <Checkbox fieldName="MerchantAuthorization">
          By checking this box, I authorize {props.merchantName} to charge my
          bank account
          {!props.ShouldShowTotalCost ? (
            <> according to the Schedule of Financing Payments</>
          ) : (
            <>
              {" "}
              on {DateFns.format(new Date(), dateFormat)} for{" "}
              <span className="has-text-weight-bold PaymentAmount">
                {formatDollarsAndCents(props.TotalCost)}
              </span>
            </>
          )}
          {props.HasFuturePayments && (
            <>
              {" "}
              and on future dates according to the Schedule of Financing
              Payments
            </>
          )}
          .
        </Checkbox>
      </Horizontal>
    </>
  );
}

function AccountNumberInput() {
  return (
    <>
      <Horizontal
        isRequired
        label={
          <>
            Account Number <RoutingAndAccountWhatIsThis />
          </>
        }
      >
        <Textbox
          type="tel"
          fieldName="AccountNumber"
          placeholder="Account Number"
          inputProps={{ autoComplete: "off" }}
        />
      </Horizontal>
      <Horizontal isRequired label="Confirm Number">
        <Textbox
          type="tel"
          fieldName="ConfirmAccountNumber"
          placeholder="Account Number"
          inputProps={{
            autoComplete: "off",
            onCutCapture: e => e.preventDefault(),
            onCopyCapture: e => e.preventDefault(),
            onPasteCapture: e => e.preventDefault(),
          }}
        />
      </Horizontal>
    </>
  );
}

function RoutingAndAccountWhatIsThis() {
  return (
    <WhatIsThisModal modalTitle="Routing and Account Numbers">
      <img src="/Images/RoutingNumber.jpg" alt="Routing Number" />
    </WhatIsThisModal>
  );
}
